import { render, staticRenderFns } from "./ResponsibleComplaint.vue?vue&type=template&id=ffe7388c"
import script from "./ResponsibleComplaint.vue?vue&type=script&lang=js"
export * from "./ResponsibleComplaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports